import { render, staticRenderFns } from "./volunteerC.vue?vue&type=template&id=507ebb58&scoped=true&"
import script from "./volunteerC.vue?vue&type=script&lang=js&"
export * from "./volunteerC.vue?vue&type=script&lang=js&"
import style0 from "./volunteerC.vue?vue&type=style&index=0&id=507ebb58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507ebb58",
  null
  
)

export default component.exports